type WarningProps = React.SVGProps<SVGSVGElement> & {
  inverseColor?: boolean;
};

export const Warning = ({ inverseColor, ...props }: WarningProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3.4035 20.6793C2.00059 20.5443 1.09758 19.3572 1.54078 18.0193C2.07157 16.417 3.10395 13.9028 5.11192 10.1842C7.27384 6.1804 9.05884 3.57287 10.2696 1.99645C11.1846 0.805076 12.8153 0.805076 13.7303 1.99645C14.941 3.57287 16.726 6.1804 18.8879 10.1842C20.8959 13.9028 21.9283 16.417 22.4591 18.0193C22.9023 19.3572 21.9993 20.5443 20.5964 20.6793C18.7026 20.8616 15.7623 21.0625 11.9999 21.0625C8.23764 21.0625 5.29733 20.8616 3.4035 20.6793Z"
      fill={inverseColor ? 'white' : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1679 6.75061C10.4715 6.86153 10.1168 7.53625 10.1813 8.23851C10.2721 9.22651 10.4164 10.6371 10.5734 11.5514C10.6496 11.9953 10.9464 12.3526 11.3938 12.4052C11.5589 12.4246 11.7592 12.4375 11.9999 12.4375C12.2405 12.4375 12.4409 12.4246 12.606 12.4052C13.0534 12.3526 13.3502 11.9953 13.4264 11.5514C13.5834 10.6371 13.7277 9.22651 13.8185 8.23851C13.883 7.53625 13.5283 6.86153 12.8318 6.75061C12.5937 6.7127 12.3164 6.6875 11.9999 6.6875C11.6834 6.6875 11.4061 6.7127 11.1679 6.75061ZM11.9999 17.7083C12.9261 17.7083 13.677 16.9575 13.677 16.0312C13.677 15.105 12.9261 14.3542 11.9999 14.3542C11.0737 14.3542 10.3228 15.105 10.3228 16.0312C10.3228 16.9575 11.0737 17.7083 11.9999 17.7083Z"
      fill="white"
    />
  </svg>
);
